import {MODALS_IDS} from '@Components/modal-container';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';

// Rendered by the pre-mounted EmailMakerBlockSheet; this only resolves the modal-render import.
export default function EmailMakerBlockManagerModalNoop(): null {
  return null;
}

// eslint-disable-next-line react-refresh/only-export-components
export const openEmailMakerBlockManagerModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.EMAIL_MAKER_BLOCK_MANAGER_MODAL,
      panelProps: {},
    })
  );
};
